// extracted by mini-css-extract-plugin
export default {"wrapper":"select_wrapper__bIO93","title":"select_title__ShyH3","input":"select_input__GMAAQ","inputError":"select_inputError__DutiX","bulletPoint":"select_bulletPoint__isAIX"};